import { buildQueryString, fetch, normalize } from '../utils/apiUtils';

class ScheduleService {

  static getTaskSections(projectType) {

    return fetch(`${process.env.REACT_APP_API_URL}/api/schedule/${projectType}/sections`)
      .then(resp => resp.json())
      .then(resp => normalize(resp.data));
  }

  static getTaskSectionById(projectType, sectionId) {
    return fetch(`${process.env.REACT_APP_API_URL}/api/schedule/${projectType}/sections/${sectionId}`)
      .then(resp => resp.json())
      .then(resp => resp.data);
  }

  static getResources(params) {

    let queryString = buildQueryString(params);

    return fetch(`${process.env.REACT_APP_API_URL}/api/schedule/resources?${queryString}`)
      .then(resp => resp.json())
      .then(resp => {
        return {
          totalCount: resp.meta.totalResults,
          items: resp.data
        }
      });
  }
}

export default ScheduleService;



// WEBPACK FOOTER //
// ./src/services/ScheduleService.js